<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" @closed="reset" :destroy-on-close="true" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="新建方式:">
        <el-radio-group v-model="type" @change="radioChange">
          <el-radio :label="1">批量新建</el-radio>
          <el-radio :label="0">单个新建</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="type===0">
        <el-form-item label="分拣框编号:" prop="basketCode">
          <el-input maxlength='20' placeholder="请输入分拣框编号" v-model="form.basketCode"></el-input>
        </el-form-item>
      </template>
      <template v-if="type===1">
        <el-form-item label="固定前缀:" prop="basketAffix">
          <el-input maxlength='10' placeholder="请输入固定前缀" v-model="form.basketAffix"></el-input>
        </el-form-item>
        <el-form-item label="分拣框个数:" prop="basketCount" >
          <!-- <el-input-number style="width:100%;" :controls="false" :max='99' placeholder="请输入分拣框个数" v-model="form.basketCount" controls-position="left"></el-input-number> -->
          <el-input maxlength='2' placeholder="请输入分拣框个数" v-model="form.basketCount"></el-input>
        </el-form-item>
      </template>
      <el-form-item label="分拣框类型:" prop="basketType">
        <el-select style="width:100%" v-model="form.basketType" placeholder="请选择分拣框类型">
          <el-option label="发货-分拣" :value="0"></el-option>
          <el-option label="组合任务-分拣" :value="1"></el-option>
          <el-option label="国内发货-分拣" :value="2"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="unOk">取 消</el-button>
      <el-button type="primary" @click="ok">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "SetBasket",
  data() {
    return {
      dialogVisible: false,
      title:'新建分拣框',
      // 新建方式
      type: 1,
      form: {
        basketCode: "",
        basketType: "",
        basketAffix:"",
        basketCount:null,
        warehouse: "",
      },
      rules:{
        basketCode:[{required:true,message:'请输入分拣框编号'}],
        basketAffix:[{required:true,validator: (rule, value, callback)=>{
          if (value === '') {
            callback(new Error('请输入固定前缀'));
          } else {
            let reg = /[^a-zA-Z0-9]/
            if(reg.test(value)){
              callback(new Error('固定前缀格式错误'));
            }
            callback();
          }
        }}],
        basketCount:[{required:true,validator: (rule, value, callback)=>{
          if (value === '') {
            callback(new Error('请输入分拣框个数'));
          } else {
            if(!Number.isInteger(Number(value)) || value < 1){
              callback(new Error('分拣框个数错误'));
            }
            callback();
          }
        }}],
        basketType:[{required:true,message:'请选择分拣框类型'}]
      }
    };
  },
  computed:{
  },
  methods: {
    open: function (title,type='') {
      type && (this.form.basketType = type)
      this.dialogVisible = true;
      this.title = title
    },
    ok: function () {
      this.$refs.form.validate((v)=>{
        if(v){
          this.dialogVisible = false;
          if(this.type === 1){
            this.$emit("batchBasket", this.form);
          }else{
            this.$emit("submitBasket", this.form);
          }
        }
      })
    },
    unOk: function () {
      this.dialogVisible = false;
    },
    reset(){
      this.type=1
      this.form={
        basketCode: "",
        basketType: "",
        basketAffix:"",
        basketCount:"",
        warehouse: ""
      }
    },
    radioChange(){
      this.$refs.form.resetFields()
    }
  }
};
</script>

<style scoped></style>
